<template>
  <div>
    <BlockReturned v-model="filter.no_bounces" @update:modelValue="update" />
    <BlockNoRef v-model="filter.skip_if_no_ref" @update:modelValue="update" />
    <BlockNoCookies
      v-model="filter.skip_if_no_cookies"
      @update:modelValue="update"
    />
    <BlockWebView
      v-model="filter.skip_if_x_requested_with"
      @update:modelValue="update"
    />
    <BlockNonUnique v-model="filter.no_onloop" @update:modelValue="update" />
  </div>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue'
import BlockReturned from './BlockReturned.vue'
import BlockNoRef from './BlockNoRef.vue'
import BlockNoCookies from './BlockNoCookies.vue'
import BlockWebView from './BlockWebView.vue'
import BlockNonUnique from './BlockNonUnique.vue'

export default defineComponent({
  name: 'TrafficFilters',
  components: {
    BlockReturned,
    BlockNoRef,
    BlockNoCookies,
    BlockWebView,
    BlockNonUnique
  },
  props: {
    modelValue: {
      type: Object,
      required: true
    },
    setDefaultValues: {
      type: Boolean,
      default: false
    }
  },
  setup(props, context) {
    const filter = computed({
      get: () => {
        const modelValue = props.modelValue
        return {
          ...modelValue,
          no_bounces: props.setDefaultValues ? true : modelValue.no_bounces,
          skip_if_no_ref: props.setDefaultValues
            ? true
            : modelValue.skip_if_no_ref,
          skip_if_no_cookies: props.setDefaultValues
            ? true
            : modelValue.skip_if_no_cookies,
          skip_if_x_requested_with: props.setDefaultValues
            ? true
            : modelValue.skip_if_x_requested_with
        } as typeof modelValue
      },
      set: (newVal) => {
        context.emit('update', newVal)
      }
    })

    const update = () => {
      const valueToUpdate = {
        no_bounces: filter.value.no_bounces,
        skip_if_no_ref: filter.value.skip_if_no_ref,
        skip_if_no_cookies: filter.value.skip_if_no_cookies,
        skip_if_x_requested_with: filter.value.skip_if_x_requested_with,
        no_onloop: filter.value.no_onloop
      }
      context.emit('update', valueToUpdate)
    }
    return { filter, update }
  }
})
</script>

<style lang="scss" scoped>
:deep(.el-checkbox) {
  display: block;
}
</style>
